var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.results
    ? _c(
        "div",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { md: "5", xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-title",
                        [
                          _c("app-companies", {
                            attrs: { filter: _vm.filter1 },
                            on: {
                              filter: function ($event) {
                                return _vm.updateFilter1($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [_vm._v(" Starter ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.results.Left.tier1
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [_vm._v(" Professional ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.results.Left.tier2
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [_vm._v(" Enterprise ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.results.Left.tier3
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            { staticClass: "mt" },
                            [
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [_vm._v(" TOTAAL ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(_vm.totalLeft)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "5", xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-title",
                        [
                          _c("app-companies", {
                            attrs: { filter: _vm.filter2 },
                            on: {
                              filter: function ($event) {
                                return _vm.updateFilter2($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            {
                              class: _vm.difference(
                                _vm.results.Left.tier1,
                                _vm.results.Right.tier1
                              ),
                            },
                            [
                              _c(
                                "w-col",
                                { staticClass: "ico", attrs: { sm: "2" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: {
                                          icon: _vm.icon(
                                            _vm.results.Left.tier1,
                                            _vm.results.Right.tier1
                                          ),
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.percentage(
                                              _vm.results.Left.tier1,
                                              _vm.results.Right.tier1
                                            )
                                          ) +
                                          " % "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "4", sm: "10" },
                                },
                                [_vm._v(" Starter ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.results.Right.tier1
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            {
                              class: _vm.difference(
                                _vm.results.Left.tier2,
                                _vm.results.Right.tier2
                              ),
                            },
                            [
                              _c(
                                "w-col",
                                { staticClass: "ico", attrs: { sm: "2" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: {
                                          icon: _vm.icon(
                                            _vm.results.Left.tier2,
                                            _vm.results.Right.tier2
                                          ),
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.percentage(
                                              _vm.results.Left.tier2,
                                              _vm.results.Right.tier2
                                            )
                                          ) +
                                          " % "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "4", sm: "10" },
                                },
                                [_vm._v(" Professional ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.results.Right.tier2
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            {
                              class: _vm.difference(
                                _vm.results.Left.tier3,
                                _vm.results.Right.tier3
                              ),
                            },
                            [
                              _c(
                                "w-col",
                                { staticClass: "ico", attrs: { sm: "2" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: {
                                          icon: _vm.icon(
                                            _vm.results.Left.tier3,
                                            _vm.results.Right.tier3
                                          ),
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.percentage(
                                              _vm.results.Left.tier3,
                                              _vm.results.Right.tier3
                                            )
                                          ) +
                                          " % "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "4", sm: "10" },
                                },
                                [_vm._v(" Enterprise ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.results.Right.tier3
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            {
                              staticClass: "mt",
                              class: _vm.difference(
                                _vm.totalLeft,
                                _vm.totalRight
                              ),
                            },
                            [
                              _c(
                                "w-col",
                                { staticClass: "ico", attrs: { sm: "2" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: {
                                          icon: _vm.icon(
                                            _vm.totalLeft,
                                            _vm.totalRight
                                          ),
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.percentage(
                                              _vm.totalLeft,
                                              _vm.totalRight
                                            )
                                          ) +
                                          " % "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "title",
                                  attrs: { md: "4", sm: "10" },
                                },
                                [_vm._v(" TOTAAL ")]
                              ),
                              _c(
                                "w-col",
                                {
                                  staticClass: "amount",
                                  attrs: { md: "6", sm: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(_vm.totalRight)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }